
import React, {PropTypes, Component} from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import StackedBarChart from '../StackedBarChart';
import styles from './NuisanceFloodingEmbed.css';
import NuisanceFloodingData from '../NuisanceFloodingData';
import { simplePlaceName, xlt } from '../../utils/utils';
import withStyles from '../../decorators/withStyles';
import * as d3 from 'd3';


const NuisanceFloodingSlide = ({data, margin, width, height, placeName, aslrStation}) => {

  const station = aslrStation;
  const stnShortName = name => name.split("-")[0].trim();
  const setTxContent = (el) => d3.select(el).attr('tx-content', 'block');

  return (
    <div className="NuisanceFloodingSlide state-content">
      <h5 className="header supertitle graph-title">{simplePlaceName(placeName).toUpperCase()} AREA*</h5>
      <h1 className="header graph-title" style={{marginTop: -6}}>Coastal flood days</h1>
      <div className="state-content">
        <div>
          <div id="location" className="projection_chart_container">
            <StackedBarChart
              data={data.aslrPoints}
              margin={margin}
              width={width}
              height={height}
              xLabel={xlt("Ten-year Period")}
              yLabel={xlt("Days of Coastal Flooding")}
            >
            </StackedBarChart>
          </div>
          <p className="map-explain" ref={setTxContent}>*Water level station <var>"{stnShortName(station.name)}"</var> is <var>{station.dist}</var> miles from <var>{simplePlaceName(placeName)}</var> and
              is the nearest station analyzed in the Climate Central study behind this figure.</p>
          <div className="cc-logo-img" />
        </div>
      </div>
    </div>
  );
};


class NuisanceFloodingEmbed extends Component {

  render() {
    const margin = {top: 20, right: 20, bottom: 55, left: 75};
    const width = 660 - margin.left - margin.right;
    const height = 350 - margin.top - margin.bottom;

    return (
      <div className="EmbedNuisanceFlooding band white">
        <section>
          <NuisanceFloodingData>
            <NuisanceFloodingSlide margin={margin} width={width} height={height} />
          </NuisanceFloodingData>
        </section>
      </div>
    )
  }
}

// Use connect solely for access to redux "dispatch";
// Don't use any state from the store. Such props will be passed directly.
export default compose(
  withStyles(styles),
  connect(() => {return {};}),
)(NuisanceFloodingEmbed);
